module.exports = __webpack_public_path__ + "9cfabb8b1ac0ee859e46349b3cd53323.pdf";